import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { handleQuerySuccess } from '../../../../hooks/useQuriesSuccess';
import { apiRequest } from '../../../../Services/Common/ApiRequest';
import Global from '../../../../Services/Common/Global';
import useSaveMutation from '../../../../hooks/apis/useSaveMutaion';
import { mapParamsBySchema } from '../../../../util';
import { WOR_BASIC_01_Schema } from './WOR_BASIC_01_Schema';

/**
 * 작업환경측정 공정별 측정주기 조회 (GetWorBasicR2)
 * - useQuery 기반, queryKey/params 변경 시 자동 재조회
 * - params: CustCd, BaseYear (스키마 mapper + context.search)
 */
export const useSearch1 = (options = {}) => {
  const { onSuccess, selectedYear } = options;
  const searchInfo = useSelector((state) => state.SearchInfo);
  const context = {
    search: {
      ...searchInfo,
      baseYear: selectedYear ?? String(new Date().getFullYear()),
    },
  };
  const params = mapParamsBySchema(WOR_BASIC_01_Schema.mapper.search1, context);

  const query = useQuery({
    queryKey: ['WorkEnvironment', 'getWorBasicR2', params],
    queryFn: () =>
      apiRequest('post', Global.urls.WorkEnvironment.getWorBasicR2, params),
    enabled: true,
  });

  useEffect(() => {
    if (!query.isSuccess) return;
    handleQuerySuccess(query.data, {
      onSuccess: async (rows) => {
        await onSuccess?.(rows);
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- query 성공 시에만 onSuccess 호출
  }, [query.isSuccess, query.dataUpdatedAt]);

  return query;
};

/**
 * 측정주기 저장 (SaveWorBasicU2)
 * - payload: List<SaveWorBasicU2Info> (buildSaveWorBasicU2Requests 결과를 그대로 전달)
 * - 서버: [FromBody] List<SaveWorBasicU2Info>, 필드 암호화 후 복호화하여 TB_BS_MEASURE_CYCLE UPSERT
 */
export const useSave1 = (options = {}) => {
  return useSaveMutation(async (payload) => {
    return apiRequest(
      'post1',
      Global.urls.WorkEnvironment.saveWorBasicU2,
      payload
    );
  }, options);
};